import type { AuthStorage } from "./auth-storage";
import { PlatformSession } from "./platform-session";
import { api } from "./session-api";
import { VkPlayAuthAdapter } from "./vkplay-auth-adapter";
import { initializeVkPlaySdk } from "./vkplay-sdk";
import type { VkPlaySdk } from "./vkplay-sdk";

type PlatformApi = Pick<typeof api, "vkPlaySession" | "session" | "profile">;

export class VkPlaySession extends PlatformSession {
  constructor(
    appId: string,
    launchParams: string,
    storage: AuthStorage,
    requests: PlatformApi = api,
    initialize: (appId: string) => Promise<VkPlaySdk> = initializeVkPlaySdk,
  ) {
    super(
      new VkPlayAuthAdapter(appId, launchParams, requests, initialize),
      storage,
      requests,
    );
  }
}
